import { Entity } from '../entity';
import type { ConsentDataObject, UserDetailConsentDataObject } from '../service';

export type UserDetailConsent = {
  consented: boolean;
  id: string;
};

export class Consent extends Entity {
  htmlContent: string;
  validFor: number;

  constructor(data: ConsentDataObject) {
    super(data);
    this.validFor = data.valid_for;
    this.htmlContent = data.html_content;
  }
}

export const createUserDetailConsent = (data: UserDetailConsentDataObject) => ({
  consented: data.consented,
  id: data.id,
});
